import React, { useContext, useEffect, useState } from "react";
import PedidosYaStyle from "../../../../assets/css/components/admin/plugins/PedidosYaStyle";
import { BiHide, BiShow } from "react-icons/bi";
import { accHomeCenter } from "../../../../hooks/api/homeCenter";
import { GlobalContext } from "../../../../contexts/GlobalContext";
import ListOfProductsToSetParams from "../../../../assets/css/components/admin/marketplace-to-marketplace/products/ListOfProductsToSetParams";
import {
  Select,
} from "../../../../assets/css/components/admin/products/ShowProductInfo/ShowProductInfo.css";
import handleAxiosError from "../../update-and-publish/functions/handleAxiosError";
import { keyAccessToken, keyUserId } from "../../../../assets/js/SessionStorageNames";
import axios from "axios";

export default function HomeCenterCredentials({
  username,
  loading,
  setLoading,
  modalNewCredential,
  setModalNewCredential,
  listUsers,
}) {
  const globalContext = useContext(GlobalContext);
  const [showPass, setShowPass] = useState(false);
  const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
  const [tarifas, setTarifas] = useState([]);

  const toggleShowPassword = (e) => {
    setShowPass(!showPass);
  };

  const [accHomeCenterData, setAccHomeCenterData] = useState({
    userName: "",
    userEmail: "",
    url: "",
    odooPricelist: "",
    idProvider: "",
    keyProvider: "",
    apiKey: "",
    channelName: "",
    channelId: "",
  });

  const [getAccHomeCenterData, setGetAccHomeCenterData] = useState({
    userName: "",
    userEmail: "",
    url: "",
    odooPricelist: "",
    idProvider: "",
    keyProvider: "",
    apiKey: "",
    channelName: "",
    channelId: "",
  });

  const handleNewAcc = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setAccHomeCenterData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleGetAccHomeCenterData = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setGetAccHomeCenterData((prevData) => ({
      ...prevData,
      [name]: value || "", // Asegúrate de que predetermine a una cadena vacía
    }));
  };

  const handleSubmitData = async (save) => {
    const entId = await globalContext.currentEnterpriseId;
    setLoading(true);
    try {
      await accHomeCenter("POST", entId, save ? getAccHomeCenterData : accHomeCenterData);
      await globalContext.showModalWithMsg(`Has actualizado la cuenta correctamente.`);
    } catch (err) {
      console.error("Error al guardar credenciales de Home Center", err);
      await globalContext.showModalWithMsg(`Ha ocurrido un error al actualizar la cuenta.`);
      alert(
        "Error al guardar credenciales de Home Center, verifica los campos y vuelve a intentarlo"
      );
    } finally {
      setLoading(false);
      if (!save) setModalNewCredential(false);
    }
  };

  useEffect(() => {
    if (listUsers && listUsers.length > 0) {
      const isUser = listUsers.filter((user) => (user.userName || user.username) === username);
      if (isUser.length > 0) {
        setGetAccHomeCenterData({
          userName: isUser[0].userName || isUser[0].username || "",
          userEmail: isUser[0].userEmail || "",
          url: isUser[0].url || "",
          odooPricelist: isUser[0].odooPricelist || "",
          idProvider: isUser[0].idProvider || "",
          keyProvider: isUser[0].keyProvider || "",
          apiKey: isUser[0].apiKey || "",
          channelName: isUser[0].channelName || "",
          channelId: isUser[0].channelId || "",
        });
      }
    }
    getPriceList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalNewCredential, listUsers, username]);

  /**
   * Function to consult the lists of available rates
   */
  async function getPriceList() {
    const entId = await globalContext.currentEnterpriseId;
    const url = `${process.env.REACT_APP_BACKEND_URL}/v1/odoo-pricelist/${entId}`;
    if (entId)
      await axios
        .get(url, {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        })
        .then((resp) => {
          const data = resp.data.data;
          setTarifas(data.priceLists);
        })
        .catch((err) => {
          console.log(err);
          handleAxiosError(
            err,
            "Disculpe, no se pudo cargar la lista de tarifas."
          );
        });
  }

  return (
    <div style={{ marginTop: 55 }}>
      {!modalNewCredential ? (
        <>
          <PedidosYaStyle.ContForm style={{ marginTop: 55 }}>
            <PedidosYaStyle.HeaderForm>
              <PedidosYaStyle.Text size="14pt" fw="500" cl="#898989" style={{ textAlign: "center" }}>
                Credenciales de {username}
              </PedidosYaStyle.Text>
            </PedidosYaStyle.HeaderForm>

            <PedidosYaStyle.BodyForm>
              {/* Sección: Información General */}
              <div style={{ padding: "20px 30px" }}>
                <PedidosYaStyle.Text size="13pt" fw="600" cl="#4a5568" style={{ marginBottom: "15px", display: "block", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px" }}>
                  Información General
                </PedidosYaStyle.Text>
                
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px", marginBottom: "20px" }}>
                  <div>
                    <PedidosYaStyle.Text size="11pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "6px" }}>
                      Nombre de Usuario
                    </PedidosYaStyle.Text>
                    <PedidosYaStyle.Input
                      name="userName"
                      value={getAccHomeCenterData.userName || ""}
                      placeholder="Nombre de Usuario"
                      onChange={handleGetAccHomeCenterData}
                      disabled={true}
                      style={{ backgroundColor: "#f7fafc", border: "1px solid #e2e8f0", borderRadius: "6px", padding: "10px 12px" }}
                    />
                  </div>
                  
                  <div>
                    <PedidosYaStyle.Text size="11pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "6px" }}>
                      Email
                    </PedidosYaStyle.Text>
                    <PedidosYaStyle.Input
                      name="userEmail"
                      value={getAccHomeCenterData.userEmail || ""}
                      placeholder="Email"
                      onChange={handleGetAccHomeCenterData}
                      disabled={true}
                      style={{ backgroundColor: "#f7fafc", border: "1px solid #e2e8f0", borderRadius: "6px", padding: "10px 12px" }}
                    />
                  </div>
                </div>

                <div style={{ marginBottom: "20px" }}>
                  <PedidosYaStyle.Text size="11pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "6px" }}>
                    URL de Logística
                  </PedidosYaStyle.Text>
                  <PedidosYaStyle.Input
                    name="url"
                    value={getAccHomeCenterData.url || ""}
                    placeholder="https://apim-prod-proxy.sodhc.co/logistica"
                    onChange={handleGetAccHomeCenterData}
                    style={{ border: "1px solid #cbd5e0", borderRadius: "6px", padding: "10px 12px", width: "100%" }}
                  />
                </div>

                <div>
                  <PedidosYaStyle.Text size="11pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "6px" }}>
                    Lista de Precios Odoo
                  </PedidosYaStyle.Text>
                  <Select
                    className="tarifa"
                    name="odooPricelist"
                    value={getAccHomeCenterData.odooPricelist || ""}
                    onChange={handleGetAccHomeCenterData}
                    style={{ border: "1px solid #cbd5e0", borderRadius: "6px", padding: "10px 12px", width: "100%" }}
                  >
                    <option value="">{getAccHomeCenterData.odooPricelist || "Seleccione una tarifa"}</option>
                    {tarifas.map((val, i) => (
                      <option key={i} value={val.name}>
                        {val.name}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>

              {/* Sección: Configuración API */}
              <div style={{ padding: "20px 30px", backgroundColor: "#f8fafc" }}>
                <PedidosYaStyle.Text size="13pt" fw="600" cl="#4a5568" style={{ marginBottom: "15px", display: "block", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px" }}>
                  Configuración del Proveedor
                </PedidosYaStyle.Text>
                
                <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "15px" }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: "15px" }}>
                    <div>
                      <PedidosYaStyle.Text size="11pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "6px" }}>
                        ID Proveedor
                      </PedidosYaStyle.Text>
                      <PedidosYaStyle.Input
                        name="idProvider"
                        value={getAccHomeCenterData.idProvider || ""}
                        placeholder=""
                        disabled={true}
                        onChange={handleGetAccHomeCenterData}
                        style={{ border: "1px solid #cbd5e0", borderRadius: "6px", padding: "10px 12px", width: "100%", backgroundColor: "#f7fafc" }}
                      />
                    </div>
                    
                    <div>
                      <PedidosYaStyle.Text size="11pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "6px" }}>
                        API Key
                      </PedidosYaStyle.Text>
                      <PedidosYaStyle.ContIconNadInputPass style={{ position: "relative" }}>
                        <PedidosYaStyle.Input
                          style={{ width: "100%", border: "1px solid #cbd5e0", borderRadius: "6px", padding: "10px 40px 10px 12px" }}
                          name="apiKey"
                          type={showPass ? "text" : "password"}
                          value={getAccHomeCenterData.apiKey || ""}
                          disabled={loading}
                          placeholder="209fa70e5b0c4b5c8bddaf0aa54b8e19"
                          autoComplete="off"
                          onChange={handleGetAccHomeCenterData}
                        />
                        <PedidosYaStyle.BtnShowPass
                          onClick={(e) => toggleShowPassword(e)}
                          style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }}
                        >
                          {showPass ? <BiHide /> : <BiShow />}
                        </PedidosYaStyle.BtnShowPass>
                      </PedidosYaStyle.ContIconNadInputPass>
                    </div>
                  </div>

                  <div>
                    <PedidosYaStyle.Text size="11pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "6px" }}>
                      Key del Proveedor
                    </PedidosYaStyle.Text>
                    <PedidosYaStyle.ContIconNadInputPass style={{ position: "relative" }}>
                      <PedidosYaStyle.Input
                        style={{ width: "100%", border: "1px solid #cbd5e0", borderRadius: "6px", padding: "10px 40px 10px 12px" }}
                        name="keyProvider"
                        type={showPass ? "text" : "password"}
                        value={getAccHomeCenterData.keyProvider || ""}
                        disabled={loading}
                        placeholder="Clave de seguridad del proveedor"
                        autoComplete="off"
                        onChange={handleGetAccHomeCenterData}
                      />
                      <PedidosYaStyle.BtnShowPass
                        onClick={(e) => toggleShowPassword(e)}
                        style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }}
                      >
                        {showPass ? <BiHide /> : <BiShow />}
                      </PedidosYaStyle.BtnShowPass>
                    </PedidosYaStyle.ContIconNadInputPass>
                  </div>
                </div>
              </div>

              {/* Sección: Configuración del Canal */}
              <div style={{ padding: "20px 30px" }}>
                <PedidosYaStyle.Text size="13pt" fw="600" cl="#4a5568" style={{ marginBottom: "15px", display: "block", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px" }}>
                  Configuración del Canal
                </PedidosYaStyle.Text>
                
                <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: "15px" }}>
                  <div>
                    <PedidosYaStyle.Text size="11pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "6px" }}>
                      Nombre del Canal
                    </PedidosYaStyle.Text>
                    <PedidosYaStyle.Input
                      name="channelName"
                      value={getAccHomeCenterData.channelName || ""}
                      placeholder="Bogota"
                      onChange={handleGetAccHomeCenterData}
                      style={{ border: "1px solid #cbd5e0", borderRadius: "6px", padding: "10px 12px", width: "100%" }}
                    />
                  </div>
                  
                  <div>
                    <PedidosYaStyle.Text size="11pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "6px" }}>
                      ID del Canal
                    </PedidosYaStyle.Text>
                    <PedidosYaStyle.Input
                      name="channelId"
                      value={getAccHomeCenterData.channelId || ""}
                      placeholder="751"
                      disabled={true}
                      onChange={handleGetAccHomeCenterData}
                      style={{ border: "1px solid #cbd5e0", borderRadius: "6px", padding: "10px 12px", width: "100%", backgroundColor: "#f7fafc" }}
                    />
                  </div>
                </div>
              </div>

              {/* Botón de Guardar */}
              <div style={{ padding: "20px 30px", borderTop: "1px solid #e2e8f0", backgroundColor: "#f8fafc" }}>
                <PedidosYaStyle.BtnSend
                  onClick={() => handleSubmitData(true)}
                  disabled={loading}
                  style={{ 
                    width: "100%", 
                    maxWidth: "300px",
                    margin: "0 auto",
                    display: "block",
                    padding: "12px 24px",
                    fontSize: "14px",
                    fontWeight: "600",
                    borderRadius: "8px",
                    backgroundColor: loading ? "#cbd5e0" : "#4299e1",
                    border: "none",
                    cursor: loading ? "not-allowed" : "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: loading ? "none" : "0 4px 6px rgba(66, 153, 225, 0.3)",
                    textAlign: "center",
                  }}
                  onMouseEnter={(e) => !loading && (e.target.style.backgroundColor = "#3182ce")}
                  onMouseLeave={(e) => !loading && (e.target.style.backgroundColor = "#4299e1")}
                >
                  {loading ? "⏳ Guardando..." : "Guardar Credenciales"}
                </PedidosYaStyle.BtnSend>
              </div>
            </PedidosYaStyle.BodyForm>
          </PedidosYaStyle.ContForm>
        </>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
            height: "100vh",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: "#5c5c5c63",
          }}
        >
          <PedidosYaStyle.ContForm
            style={{
              position: "absolute",
              maxWidth: 700,
              margin: "auto",
              width: "100%",
            }}
          >
            <ListOfProductsToSetParams.Close
              style={{ top: 10, right: 10, position: "absolute" }}
              onClick={() => setModalNewCredential(false)}
            ></ListOfProductsToSetParams.Close>
            <PedidosYaStyle.HeaderForm style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "white", padding: "20px" }}>
              <PedidosYaStyle.Text size="16pt" fw="600" style={{ color: "white" }}>
                Nueva Credencial Home Center
              </PedidosYaStyle.Text>
            </PedidosYaStyle.HeaderForm>

            <PedidosYaStyle.BodyForm style={{ maxHeight: "70vh", overflowY: "auto" }}>
              {/* Sección: Información General */}
              <div style={{ padding: "20px 25px" }}>
                <PedidosYaStyle.Text size="13pt" fw="600" cl="#4a5568" style={{ marginBottom: "15px", display: "block", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px" }}>
                  Información General
                </PedidosYaStyle.Text>
                
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "15px" }}>
                  <div>
                    <PedidosYaStyle.Text size="10pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "5px" }}>
                      Nombre de Usuario *
                    </PedidosYaStyle.Text>
                    <PedidosYaStyle.Input
                      name="userName"
                      value={accHomeCenterData.userName || ""}
                      placeholder="INTERNACIONAL DMC 2050 SAS"
                      onChange={handleNewAcc}
                      style={{ border: "1px solid #cbd5e0", borderRadius: "6px", padding: "8px 10px", width: "100%" }}
                    />
                  </div>
                  
                  <div>
                    <PedidosYaStyle.Text size="10pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "5px" }}>
                      Email *
                    </PedidosYaStyle.Text>
                    <PedidosYaStyle.Input
                      name="userEmail"
                      value={accHomeCenterData.userEmail || ""}
                      placeholder="email@ejemplo.com"
                      onChange={handleNewAcc}
                      style={{ border: "1px solid #cbd5e0", borderRadius: "6px", padding: "8px 10px", width: "100%" }}
                    />
                  </div>
                </div>

                <div style={{ marginBottom: "15px" }}>
                  <PedidosYaStyle.Text size="10pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "5px" }}>
                    URL de Logística *
                  </PedidosYaStyle.Text>
                  <PedidosYaStyle.Input
                    name="url"
                    value={accHomeCenterData.url || ""}
                    placeholder="https://apim-prod-proxy.sodhc.co/logistica"
                    onChange={handleNewAcc}
                    style={{ border: "1px solid #cbd5e0", borderRadius: "6px", padding: "8px 10px", width: "100%" }}
                  />
                </div>

                <div>
                  <PedidosYaStyle.Text size="10pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "5px" }}>
                    Lista de Precios Odoo *
                  </PedidosYaStyle.Text>
                  <Select
                    className="tarifa"
                    name="odooPricelist"
                    value={accHomeCenterData.odooPricelist || ""}
                    onChange={handleNewAcc}
                    style={{ border: "1px solid #cbd5e0", borderRadius: "6px", padding: "8px 10px", width: "100%" }}
                  >
                    <option value="">Seleccione una tarifa</option>
                    {tarifas.map((val, i) => (
                      <option key={i} value={val.name}>
                        {val.name}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>

              {/* Sección: Configuración API */}
              <div style={{ padding: "15px 25px", backgroundColor: "#f8fafc" }}>
                <PedidosYaStyle.Text size="13pt" fw="600" cl="#4a5568" style={{ marginBottom: "15px", display: "block", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px" }}>
                  Configuración del Proveedor
                </PedidosYaStyle.Text>
                
                <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "12px" }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: "12px" }}>
                    <div>
                      <PedidosYaStyle.Text size="10pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "5px" }}>
                        ID Proveedor *
                      </PedidosYaStyle.Text>
                      <PedidosYaStyle.Input
                        name="idProvider"
                        value={accHomeCenterData.idProvider || ""}
                        placeholder="6535"
                        onChange={handleNewAcc}
                        style={{ border: "1px solid #cbd5e0", borderRadius: "6px", padding: "8px 10px", width: "100%" }}
                      />
                    </div>
                    
                    <div>
                      <PedidosYaStyle.Text size="10pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "5px" }}>
                        API Key *
                      </PedidosYaStyle.Text>
                      <PedidosYaStyle.ContIconNadInputPass style={{ position: "relative" }}>
                        <PedidosYaStyle.Input
                          style={{ width: "100%", border: "1px solid #cbd5e0", borderRadius: "6px", padding: "8px 35px 8px 10px" }}
                          name="apiKey"
                          type={showPass ? "text" : "password"}
                          value={accHomeCenterData.apiKey || ""}
                          disabled={loading}
                          placeholder="209fa70e5b0c4b5c8bddaf0aa54b8e19"
                          autoComplete="off"
                          onChange={handleNewAcc}
                        />
                        <PedidosYaStyle.BtnShowPass
                          onClick={(e) => toggleShowPassword(e)}
                          style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)" }}
                        >
                          {showPass ? <BiHide /> : <BiShow />}
                        </PedidosYaStyle.BtnShowPass>
                      </PedidosYaStyle.ContIconNadInputPass>
                    </div>
                  </div>

                  <div>
                    <PedidosYaStyle.Text size="10pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "5px" }}>
                      Key del Proveedor *
                    </PedidosYaStyle.Text>
                    <PedidosYaStyle.ContIconNadInputPass style={{ position: "relative" }}>
                      <PedidosYaStyle.Input
                        style={{ width: "100%", border: "1px solid #cbd5e0", borderRadius: "6px", padding: "8px 35px 8px 10px" }}
                        name="keyProvider"
                        type={showPass ? "text" : "password"}
                        value={accHomeCenterData.keyProvider || ""}
                        disabled={loading}
                        placeholder="Clave de seguridad"
                        autoComplete="off"
                        onChange={handleNewAcc}
                      />
                      <PedidosYaStyle.BtnShowPass
                        onClick={(e) => toggleShowPassword(e)}
                        style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)" }}
                      >
                        {showPass ? <BiHide /> : <BiShow />}
                      </PedidosYaStyle.BtnShowPass>
                    </PedidosYaStyle.ContIconNadInputPass>
                  </div>
                </div>
              </div>

              {/* Sección: Configuración del Canal */}
              <div style={{ padding: "15px 25px" }}>
                <PedidosYaStyle.Text size="13pt" fw="600" cl="#4a5568" style={{ marginBottom: "15px", display: "block", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px" }}>
                  Configuración del Canal
                </PedidosYaStyle.Text>
                
                <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: "12px" }}>
                  <div>
                    <PedidosYaStyle.Text size="10pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "5px" }}>
                      Nombre del Canal *
                    </PedidosYaStyle.Text>
                    <PedidosYaStyle.Input
                      name="channelName"
                      value={accHomeCenterData.channelName || ""}
                      placeholder="Bogota"
                      onChange={handleNewAcc}
                      style={{ border: "1px solid #cbd5e0", borderRadius: "6px", padding: "8px 10px", width: "100%" }}
                    />
                  </div>
                  
                  <div>
                    <PedidosYaStyle.Text size="10pt" fw="500" cl="#718096" style={{ display: "block", marginBottom: "5px" }}>
                      ID del Canal *
                    </PedidosYaStyle.Text>
                    <PedidosYaStyle.Input
                      name="channelId"
                      value={accHomeCenterData.channelId || ""}
                      placeholder="751"
                      onChange={handleNewAcc}
                      style={{ border: "1px solid #cbd5e0", borderRadius: "6px", padding: "8px 10px", width: "100%" }}
                    />
                  </div>
                </div>
              </div>

              {/* Botón de Guardar */}
              <div style={{ padding: "20px 25px", borderTop: "1px solid #e2e8f0", backgroundColor: "#f8fafc", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                <button
                  onClick={() => setModalNewCredential(false)}
                  style={{
                    padding: "10px 20px",
                    fontSize: "13px",
                    fontWeight: "500",
                    borderRadius: "6px",
                    backgroundColor: "white",
                    border: "1px solid #cbd5e0",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    color: "#4a5568"
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = "#f7fafc"}
                  onMouseLeave={(e) => e.target.style.backgroundColor = "white"}
                >
                  Cancelar
                </button>
                <PedidosYaStyle.BtnSend
                  onClick={() => handleSubmitData(false)}
                  disabled={loading}
                  style={{ 
                    padding: "10px 24px",
                    fontSize: "13px",
                    fontWeight: "600",
                    borderRadius: "6px",
                    backgroundColor: loading ? "#cbd5e0" : "#48bb78",
                    border: "none",
                    cursor: loading ? "not-allowed" : "pointer",
                    transition: "all 0.2s ease",
                    boxShadow: loading ? "none" : "0 2px 4px rgba(72, 187, 120, 0.4)",
                    color: "white"
                  }}
                  onMouseEnter={(e) => !loading && (e.target.style.backgroundColor = "#38a169")}
                  onMouseLeave={(e) => !loading && (e.target.style.backgroundColor = "#48bb78")}
                >
                  {loading ? "⏳ Guardando..." : "Crear Credencial"}
                </PedidosYaStyle.BtnSend>
              </div>  
            </PedidosYaStyle.BodyForm>
          </PedidosYaStyle.ContForm>
        </div>
      )}
    </div>
  );
}


